// @flow

import * as React from 'react';

import JobInformationStore from 'app/stores/JobInformationStore';

type Props = {
  job: {
    id: string,
    basePath: string
  }
};

type State = {
  env: { [string]: string },
  showExport: boolean
};

const getStateFromStore = (jobId) => JobInformationStore.get(jobId, "environment");

export default class JobEnvironment extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      env: getStateFromStore(props.job.id),
      showExport: false
    };
  }

  _refetchStore() {
    return JobInformationStore.refetch(this.props.job.id, "environment", this.props.job.basePath + "/environment");
  }

  componentDidMount() {
    JobInformationStore.addChangeListener(this.handleStoreChange);
    this._refetchStore();
  }

  componentWillUnmount() {
    JobInformationStore.removeChangeListener(this.handleStoreChange);
  }

  renderEnvNode() {
    if (this.state.env) {
      let deprecatedNode, value;
      const nonDeprecated = [];

      for (const key in this.state.env) {
        value = this.state.env[key];
        if ((key.indexOf("BUILDKITE_PROJECT") === 0) || (key.indexOf("BUILDBOX_PROJECT") === 0) || (key === "BUILDKITE_STEP_IDENTIFIER")) {
          // deprecated
        } else if (key.indexOf("BUILDBOX") === -1) {
          nonDeprecated.push(this.shellFriendlyEnvironmentString(key, value));
        }
      }

      const deprecated = {};
      let hasDeprecated = false;

      for (const key in this.state.env) {
        value = this.state.env[key];
        if (key.indexOf("BUILDBOX") === 0) {
          hasDeprecated = true;
          deprecated[key] = value;
        }
        if (key === "BUILDKITE_STEP_IDENTIFIER") {
          hasDeprecated = true;
          deprecated[key] = value;
        }
        if ((key.indexOf("BUILDKITE_PROJECT") === 0) || (key.indexOf("BUILDBOX_PROJECT") === 0)) {
          hasDeprecated = true;
          deprecated[key] = value;
        }
      }

      if (hasDeprecated) {
        deprecatedNode = (
          <div>
            <h3 className="h4 mt2 mb1 pb0">
              Deprecated Environment Variables
            </h3>
            <p className="p0 m0 mb2">
              The following environment variables have been deprecated, and should no longer be used:
            </p>
            <pre className="code">
              <code>
                {Object.keys(deprecated).map((key) => this.shellFriendlyEnvironmentString(key, deprecated[key]) + "\n")}
              </code>
            </pre>
          </div>
        );
      }

      return (
        <div>
          <pre className="code">
            <code>
              {nonDeprecated.sort().map((line) => `${line}\n`)}
            </code>
          </pre>
          {deprecatedNode}
        </div>
      );
    }

    return <span>Loading…</span>;
  }

  render() {
    return (
      <div data-testid="JobEnvironmentComponent" className="relative">
        {this.renderExportButton()}
        {this.renderEnvNode()}
      </div>
    );
  }

  renderExportButton() {
    const label = (
      this.state.showExport
        ? "Hide"
        : "Show"
    );

    return (
      <button
        className="btn btn-outline border-gray hover-black bg-white absolute border regular rounded h5"
        style={{ top: "1rem", right: "1rem", fontSize: "13px" }}
        onClick={this.handleShowExportClick}
      >
        {label}
        {" "}
        <code className="monospace">
          export
        </code>
        {" Prefix"}
      </button>
    );
  }

  handleShowExportClick = () => {
    this.setState({ showExport: !this.state.showExport });
  };

  handleStoreChange = () => {
    this.setState({ env: getStateFromStore(this.props.job.id) });
  };

  shellFriendlyEnvironmentString(key: string, value: string) {
    const valueWithEscapedDoubleQuotes = value.replace(/([\\"])/g, "\\$1");

    const envString = `${key}="${valueWithEscapedDoubleQuotes}"`;

    if (this.state.showExport) {
      return `export ${envString}`;
    }

    return envString;
  }
}
